// Sku elegido en el catálogo del portal, ligado a la sesión del wizard. Los pasos 01-03 navegan
// sin el `?sku=`, así que «Elige el teléfono» lo recupera de aquí.
const keyOf = (sessionId: string): string => `wizard:linked-sku:${sessionId}`;

export function rememberLinkedSku(sessionId: string, sku: string): void {
    try {
        sessionStorage.setItem(keyOf(sessionId), sku);
    } catch {
        /* sin almacenamiento el paso 04 abre sin equipo elegido */
    }
}

export function peekLinkedSku(sessionId: string): string | undefined {
    try {
        return sessionStorage.getItem(keyOf(sessionId)) ?? undefined;
    } catch {
        return undefined;
    }
}

export function forgetLinkedSku(sessionId: string): void {
    try {
        sessionStorage.removeItem(keyOf(sessionId));
    } catch {
        /* nada que borrar */
    }
}
